import './Input.css'

import { Icon, ICONS, type IconName } from './Icon'

import { forwardRef, useImperativeHandle, useRef, useState } from 'react'

type InputProps = {
    name: string
    [key: string]: any
    flex?: number
    resetable?: boolean
    onReset?: () => void
    inputIcon?: IconName
    label?: string
    labelIcon?: IconName
    required?: boolean
    type?: string
    error?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ name, inputIcon = null, label = null, labelIcon = null, required = false, type = 'text', resetable = false, onReset = undefined, flex = 1, error = undefined, ...props }, ref) => {
        const innerRef = useRef<HTMLInputElement>(null)
        const [showingPassword, setShowingPassword] = useState(false)
        const [inputType, setInputType] = useState(type)

        let classes = ''

        if (label) {
            classes += 'no-label '
        }
        if (inputIcon) {
            classes += 'indent '
        }
        if (error) {
            classes += 'error '
        }

        function togglePasswordVisibility() {
            setShowingPassword(!showingPassword)
            if (inputType === 'password') {
                setInputType('text')
            } else if (inputType === 'text') {
                setInputType('password')
            }
        }

        useImperativeHandle(ref, () => innerRef.current!, [innerRef])

        return (
            <div className='input-container'>
                {label ? (
                    <div className='label-container'>
                        {labelIcon ? <Icon name={labelIcon} /> : null}
                        <label htmlFor={name}>{label}</label>
                    </div>
                ) : null}
                <div className='input-icon-container'>
                    {inputIcon ? <Icon name={inputIcon} /> : null}
                    <input
                        id={name}
                        className={classes}
                        ref={innerRef}
                        type={inputType}
                        name={name}
                        required={required}
                        {...props}
                    />
                </div>
                {error && <p className='input-error'>{error}</p>}
                {type === 'password' ? (
                    <div className='toggle-password'>
                        <Icon
                            name={showingPassword ? ICONS.SHOW_PASSWORD : ICONS.HIDE_PASSWORD}
                            onClick={togglePasswordVisibility}
                        />
                    </div>
                ) : null}
            </div>
        )
    },
)

export default Input
